import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Countdown from 'react-countdown';
import styles from '../styles.module.scss';
export var InviteTimerCounter = function (props) { return (_jsx("div", { className: styles.countdown, children: _jsx(Countdown, { date: props.countdownTo, renderer: function (countdownProps) {
            if (countdownProps.completed) {
                return _jsx("span", { children: "epxired!" });
            }
            return (_jsxs(_Fragment, { children: [_jsx("span", { children: "".concat(countdownProps.minutes > 0 ? countdownProps.minutes : '', ":").concat(countdownProps.seconds) }), _jsx("span", { children: countdownProps.minutes > 0 ? 'min' : 'sec' })] }));
        } }) })); };
